export default __webpack_public_path__ + "media/images/star-ceeb5967cf829b12e28a95e1630b9cb0.svg";